<section id="stats" class="stats-section">
  <div class="container">
    <div class="stats-glass-card reveal-scale">
      <div class="stats-grid">
        @for (item of stats; track item.title; let i = $index) {
          <div class="stat-item reveal-on-scroll" [class]="'delay-' + (i + 1)">
            <div class="icon-box">
              @if (item.icon === 'award') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/></svg>
              } @else if (item.icon === 'home') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              } @else if (item.icon === 'user-check') {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><polyline points="17 11 19 13 23 9"/></svg>
              } @else {
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg>
              }
            </div>
            <div class="stat-details">
              <div class="stat-number">{{ item.stat }}</div>
              <div class="stat-desc">{{ item.description }}</div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
